<script>
    import DeliveryAddressApi from '../delivery-address-api';
    import { useVuelidate } from '@vuelidate/core';
    import * as validators from '@vuelidate/validators';
    import { createI18nMessage, helpers } from '@vuelidate/validators';
    import FormInputText from './form-input-text';
    const messagePath = ({ $validator }) => `Vuelidate.${$validator.charAt(0).toUpperCase() + $validator.slice(1)}`;
    import i18n from '@/Scripts4.0/checkout/delivery-address/vue-deliveryaddress-i18n.js';
    const withI18nMessage = createI18nMessage({ t: i18n.global.t.bind(i18n), messagePath });
    export const required = withI18nMessage(validators.required);
    export const email = withI18nMessage(validators.email);
    export const maxLength = withI18nMessage(validators.maxLength, { withArguments: true });
    export  const minLength = withI18nMessage(validators.minLength, { withArguments: true });
    import { ref } from 'vue';

    export const requiredIf = (condition, attribute) => {
        return helpers.withParams(
            { type: 'requiredIf', attribute },
            withI18nMessage(validators.requiredIf(condition))
        );
    };

    export default {
        components: {
            'form-input-text': FormInputText
        },
        props: {
         
        },
        setup() {            
            return { v$: useVuelidate() }
        },
        data: function () {
            return {
                isLoading: false,
                showApp: false,
                selected: '',
                currentAddress: {
                    Email: '',
                    MobilePhone: '',
                    Attention: '',
                },
                enableDeleteDropdown: this.$currentDeliveryAddressDeleteActive,
                addressList: [],
                currentTarget: this.$currentDeliveryAddressTargetSelector,
                deleteTarget: this.$currentDeliveryAddressDeleteTargetSelector,
                isPreview: this.$currentDeliveryAddressIsPreview,
                isReadOnly: this.$currentDeliveryAddressIsReadOnly,
                isMobileNumberMandatory: false,
                isEmailMandatory: false,
                //mobilephone: '', // Ensure mobilephone is also defined if used
                //attention: '', // Ensure attention is also defined if used
                //email: '', // Ensure email is also defined if used
            } 
        },
        validations() {
            return {
                currentAddress: {
                    Email: {
                        maxLength: helpers.withParams({ max: 80 }, maxLength(80)),
                        required: requiredIf(this.isEmailMandatory, this.$t('CUSTOMER_REGISTRATION.Email')),
                        $lazy: true,
                        email
                    },
                    
                    MobilePhone: {
                        //required: conditionalRequired(this.isMobileNumberMandatory, this.$t('CUSTOMER_REGISTRATION.DeliveryMobilePhoneNumber')),
                        required: requiredIf(this.isMobileNumberMandatory, this.$t('CUSTOMER_REGISTRATION.DeliveryMobilePhoneNumber')),
                        maxLength: helpers.withParams({ max: 50 }, maxLength(50)),
                        minLength: helpers.withParams({ min: 6 }, minLength(6))
                    },
                    Attention: {
                        maxLength: helpers.withParams({ max: 50 }, maxLength(50)),
                        
                    }
                }
            };
        },
        mounted: function () {
            this.$registrationVm.listDeliveryAddressValidation = this.listValidation;
            this.$registrationVm.saveDeliveryAddressChanges = this.saveChanges;
            this.loadAddresses();
            var loadMethod = this.loadAddresses;
            var me = this;
            PubSub.subscribe("DeliveryAddress.NewAddressAdded", function (event, data) {
                if (data.id > 0) {
                    me.selected = data.id;
                    DeliveryAddressApi.setSelectedDeliveryAddress(data.id)
                        .then(() => {
                            loadMethod().then(() => {
                                me.publishCurrentZipCode();
                            });
                        });
                }
                else loadMethod();
            });

            PubSub.subscribe("DeliveryAddress.ShowDeliveryAddressApp", async function (event, data) {
                await me.loadAddresses();

                me.$nextTick(() => {
                    me.showApp = true;
                });
            });

            PubSub.subscribe("DeliveryAddress.ClearAndHideDeliveryAddress", function (event, data) {
                me.selected = '';
                me.currentAddress =  {
                    Email: '',
                    MobilePhone: '',
                    Attention: '',
                },

                me.showApp = false;
            });

            this.$nextTick(() => {
                this.showApp = true;
            });
        },
        beforeUnmount: function () {
            PubSub.unsubscribe("DeliveryAddress.NewAddressAdded");
        },
        methods: {
            

            loadAddresses: async function() {
                this.isLoading = true;

                try {
                    const currentDeliveryAddress = await DeliveryAddressApi.getCurrentDeliveryAddress();
                    if (!currentDeliveryAddress.data.Success){
                        return;
                    }
                    const isDeliveryPhoneMandatory = await DeliveryAddressApi.isDeliveryPhoneMandatory();
                    if (isDeliveryPhoneMandatory.data !== undefined) {
                        this.isMobileNumberMandatory = isDeliveryPhoneMandatory.data;
                    }

                    const isDeliveryEmailMandatory = await DeliveryAddressApi.isDeliveryEmailMandatory();
                    if (isDeliveryEmailMandatory.data !== undefined) {
                        this.isEmailMandatory = isDeliveryEmailMandatory.data;
                    }

                    this.currentAddress = currentDeliveryAddress.data.DeliveryAddress;
                    this.selected = this.currentAddress.EkstraLeveringsAdresseId;

                    if (this.isPreview)
                        return;

                    const listDeliveryAddresses = await DeliveryAddressApi.listDeliveryAddresses();
                    if (!listDeliveryAddresses.data.Success) return;

                    this.addressList = listDeliveryAddresses.data.DeliveryAddresses;
                } catch(error) {
                    console.log(error);
                } finally {
                    this.isLoading = false;
                }
            },
            close: function () {
            },

      
            clickNewDeliveryAddress: function (data, event) {
                PubSub.publish("DeliveryAddress.ShowCreateNew");
            },
            clickRemoveDeliveryAddress: function (event) {
                if (confirm(this.$t("DeliveryAddress.ConfirmRemoveDeliveryAddress"))) {
                    DeliveryAddressApi.removeDeliveryAddress(this.currentAddress.EkstraLeveringsAdresseId)
                        .then((result) => {
                            this.$toast.success(this.$t('DeliveryAddress.AddressWasRemoved'));
                            this.loadAddresses().then(() => {
                                DeliveryAddressApi.setSelectedDeliveryAddress(this.selected);
                                this.publishCurrentZipCode();
                            });
                            
                        });
                    
                }
            },
            change: function () {
                if (this.selected === 0)
                    return;
                let me = this;
                this.currentAddress = this.addressList.find(address => address.EkstraLeveringsAdresseId === this.selected)
                DeliveryAddressApi.setSelectedDeliveryAddress(this.selected)
                    .then(() => {
                        PubSub.publish("DeliveryAddress.SelectedDeliveryAddressWasChanged", this.selected <= 0);
                       me.$emit('address-changed', me.currentAddress);
                    });
                this.publishCurrentZipCode();
            },

            publishCurrentZipCode: function () {
                var data = { zipCode: this.currentAddress.PostCode };
                PubSub.publish(mcWeb.events.customerRegistration.onChangedZipCode, data);
                PubSub.publish("DeliveryAddress.ChangedSelectedDeliveryAddress", this.selected <= 0);
            },

            listValidation: function () {
                this.v$.currentAddress.$touch();
                let validationList = [];
                if (this.v$.currentAddress.Email.$invalid) {
                    validationList.push({
                        elem: document.getElementById('current-delivery-address-email'),
                        valid: false,
                        rule: this.v$.currentAddress.Email.$errors[0].$validator,
                        message: this.v$.currentAddress.Email.$errors[0].$message
                    });
                }
                else {
                    validationList.push({ elem: document.getElementById('current-delivery-address-email'), valid: true });
                }
                if (this.v$.currentAddress.Attention.$invalid) {
                    validationList.push({
                        elem: document.getElementById('current-delivery-address-attention'),
                        valid: false,
                        rule: this.v$.currentAddress.Attention.$errors[0].$validator,
                        message: this.v$.currentAddress.Attention.$errors[0].$message
                    });
                }
                else {
                    validationList.push({ elem: document.getElementById('current-delivery-address-attention'), valid: true });
                }
                if (this.v$.currentAddress.MobilePhone.$invalid) {
                    validationList.push({
                        elem: document.getElementById('current-delivery-address-mobile'),
                        valid: false,
                        rule: this.v$.currentAddress.MobilePhone.$errors[0].$validator,
                        message: this.v$.currentAddress.MobilePhone.$errors[0].$message
                    });
                }
                else {
                    validationList.push({ elem: document.getElementById('current-delivery-address-mobile'), valid: true });
                }
                return validationList;
            },
            async saveChanges() {
                let me = this;
                if (me.currentAddress.EkstraLeveringsAdresseId == null || me.currentAddress.EkstraLeveringsAdresseId < 0)
                {//this ID belongs to the default address, which this could should not try to save
                    return Promise.resolve({ Success: true });
                }

                this.v$.currentAddress.$touch();
                if (this.v$.currentAddress.$invalid) {
                    this.$toast.error(this.$t('DeliveryAddress.InvalidData'));
                    return Promise.resolve({ Success: false });
                }
                return DeliveryAddressApi.updateCartDeliveryAddressContactDetails(me.currentAddress)
                    .then((result) => {                        
                        return Promise.resolve(result.data);
                    });
            }
        },
        computed: {
            isDefaultAddressSelected () {
                return this.selected === '' || this.selected < 0;
            },
            previewClass() {
                if (this.isPreview)
                    return '';
                return 'preview-adr';
            },
            readOnly() {
                return this.isReadOnly;
            }
            ,
            selectedAddress() {
                return {

                }
            },
            mobilePhoneIcon() {
                return this.isMobileNumberMandatory ? 'icon-star' : '';
            },

            emailIcon() {
                return this.isEmailMandatory ? 'icon-star' : '';
            },

            showDropdown() {
                return !this.isPreview && this.showApp;
            },

            showAddressField() {
                return !this.isDefaultAddressSelected && this.showApp;
            },

        }


    };

</script>
<template>
    <teleport :to="deleteTarget" v-if="showDropdown">
        <div class="col-xs-12 col-sm-6 delivery-address-picker">
            <select v-model="selected" @change="change">
                <option v-for="option in addressList" :value="option.EkstraLeveringsAdresseId">
                    {{option.Name}} - {{option.City}} - {{option.PostCode}} - {{option.Address1}}
                </option>

            </select>
        </div>
        <div class="col-xs-12 col-sm-6 delivery-address-buttons">       
            <button type="button" class="btn left" v-show="!isReadOnly" @click="clickNewDeliveryAddress">{{$t("DeliveryAddress.NewDeliveryAddress")}}</button>
            <button type="button" v-show="!isDefaultAddressSelected &&  !readOnly" class="btn right" @click="clickRemoveDeliveryAddress">{{$t("DeliveryAddress.RemoveDeliveryAddress")}}</button>
        </div>
        <div class="center-block"  v-if="isLoading">
            <i class="icon-spinner animate-spin"></i>
        </div>
    </teleport>
    <teleport :to="currentTarget" v-if="showAddressField">
        
        <fieldset :class="previewClass">
            <legend class="preview-delivery-title">
                {{
$t('CHECKOUT.PreviewShippingAddress')
                }}
            </legend>
            <div class="preview-delivery-right col-xs-12 col-sm-6">
                <div class="center-block" v-if="isLoading">
                    <i class="icon-spinner animate-spin"></i>
                </div>
                <ul class="preview-list" v-if="currentAddress !== null">
                    <li class="preview-delivery-name">{{currentAddress.Name}}</li>
                    <li class="preview-delivery-address">{{currentAddress.Address1}}</li>
                    <li class="preview-delivery-adresstilleg" v-if="currentAddress.Address2 != null && currentAddress.Address2.length > 0">{{currentAddress.Address2}}</li>
                    <li class="preview-delivery-adresstilleg" v-if="currentAddress.Address3 != null && currentAddress.Address3.length > 0">{{currentAddress.Address3}}</li>
                    <li class="preview-delivery-post">
                        <span class="preview-delivery-zip">{{currentAddress.PostCode}}</span>
                        <span class="preview-delivery-city">{{currentAddress.City}}</span>
                    </li>
                    <li class="preview-delivery-country" v-if="currentAddress.Country != null && currentAddress.Country.length > 0">{{currentAddress.Country}}</li>
                    <li class="preview-delivery-contact fixed-error-height smart-label" v-if="!isPreview">
                        <form-input-text v-model:value="currentAddress.Attention"
                                         :v="v$.currentAddress.Attention"
                                         input-id="current-delivery-address-attention"
                                         :validate-upon-blur="true"
                                         :label="$t('CUSTOMER_REGISTRATION.WizzardContactPerson')"
                                         :hideLabel="true"
                                         class="active"
                                         name="levContactName"
                                         placeholder="$t('CUSTOMER_REGISTRATION.WizzardContactPerson')"
                                         input-class="form-control reg-textbox"
                                         :hideErrors="true"
                                         />
                    </li>
                    <li class="preview-delivery-contact" v-if="isPreview &&currentAddress.Attention != null && currentAddress.Attention.length > 0">
                        {{currentAddress.Attention}}
                    </li>
                    <li class="preview-delivery-mobile fixed-error-height smart-label" v-if="!isPreview">
                        <form-input-text v-model:value="currentAddress.MobilePhone"
                                         :v="v$.currentAddress.MobilePhone"
                                         :icon="mobilePhoneIcon"
                                         :validate-upon-blur="true"
                                         
                                         input-id="current-delivery-address-mobile"
                                         :label="$t('CUSTOMER_REGISTRATION.DeliveryMobilePhoneNumber')"
                                         :hideLabel="true"
                                         :hideErrors="true"
                                         class="active"
                                         name="phone"
                                         placeholder="$t('CUSTOMER_REGISTRATION.DeliveryMobilePhoneNumber')"
                                         input-class="form-control reg-textbox"
                                         
                                         />
                    </li>
                    <li class="preview-delivery-mobile" v-if="isPreview && currentAddress.MobilePhone != null && currentAddress.MobilePhone.length >0">
                        {{currentAddress.MobilePhone}}
                    </li>

                    <li class="preview-delivery-email fixed-error-height smart-label" v-if="!isPreview">
                        <form-input-text v-model:value="currentAddress.Email"
                                         input-id="current-delivery-address-email"
                                         :validate-upon-blur="true"
                                         :lazy-validation="true"
                                         :v="v$.currentAddress.Email"
                                         :label="$t('LOGINOUT.ValidEmail')"
                                         :hideLabel="true"
                                         :hideErrors="true"
                                         name="email"
                                         class="active"
                                         :icon="emailIcon"
                                         placeholder="$t('LOGINOUT.ValidEmail')"
                                         input-class="form-control reg-textbox"
                                         
                                         />
                    </li>
                    <li class="preview-delivery-email" v-if="isPreview && currentAddress.Email != null && currentAddress.Email.length > 0">
                        {{currentAddress.Email}}
                    </li>
                </ul>                
            </div>
        </fieldset>
    </teleport>
</template>

<style lang="scss">
    .customer-registration {
        & .preview-list {
            & .preview-delivery-email:before {
                content: "\f0e0";
            }
        }

       

        & #vue-current-delivery-info .preview-adr {
            margin: 1.2em;
        }

        & .preview-adr .preview-delivery-zip {
                margin-right: 0.5em;
            }

        & #delivery-address-delete-info-placeholder {
            margin-top: 10px;

            & .delivery-address-picker {
                margin-top: 10px;
            }

            & .delivery-address-buttons {
                margin-top: 10px;
            }

            & .col-sm-6.delivery-address-picker {
                padding-right: 0px;

                @media (max-width: 767px) {
                    padding-right: 15px;
                }
            }

            & select {
                width: 100%;
                height: 34px;
                padding-left: 10px;
            }

            & button {
                width: calc(50% - 10px);

                &.left {
                    float: left;
                }

                &.right {
                    float: right;
                    margin-right: 0px;
                }
            }

            @media (min-width: 768px) {

                & button {
                    margin-right: 15px;
                }
            }

            @media (max-width: 767px) {
                & select {
                    margin-bottom: 15px;
                }
            }
        }
    }
</style>